import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraBadge, SpecraDataTable, SpecraEntityCell, SpecraLink } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useNavigate } from 'react-router-dom';
import { renderRouterLink } from '../../lib/renderRouterLink';
const STATUS_TONE = {
    Draft: 'neutral',
    'In progress': 'info',
    Submitted: 'success',
    Closed: 'neutral',
    Active: 'info',
    Archived: 'neutral',
    'Pre-award': 'violet'
};
/** "6 Nov 2026" from YYYY-MM-DD (or RFC3339); "—" when empty. */ export function formatDueDate(value) {
    if (!value) return '—';
    const d = new Date(value.length === 10 ? `${value}T00:00:00Z` : value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    });
}
function PursuitsLine({ row }) {
    if (row.pursuits.length === 0) return null;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: row.pursuits.map((p, i)=>/*#__PURE__*/ _jsxs("span", {
                children: [
                    i > 0 ? ' · ' : '',
                    p.href ? /*#__PURE__*/ _jsx(SpecraLink, {
                        href: p.href,
                        renderLink: renderRouterLink,
                        children: p.label
                    }) : p.label
                ]
            }, p.id))
    });
}
/**
 * GRW-02: thin `SpecraDataTable` wrapper shared by the RFI-response and
 * Proposal lists (the accepted wrapper pattern, like `EntityTable`).
 */ export function WorkspaceRows({ rows, loading, dueColumn, empty, error }) {
    const navigate = useNavigate();
    const columns = [
        {
            id: 'title',
            header: 'Name',
            cell: (row)=>/*#__PURE__*/ _jsx(SpecraEntityCell, {
                    title: /*#__PURE__*/ _jsx(SpecraLink, {
                        href: row.href,
                        renderLink: renderRouterLink,
                        children: row.title
                    }),
                    description: /*#__PURE__*/ _jsx(PursuitsLine, {
                        row: row
                    })
                })
        },
        {
            id: 'status',
            header: 'Status',
            cell: (row)=>/*#__PURE__*/ _jsx(SpecraBadge, {
                    variant: STATUS_TONE[row.statusLabel] ?? 'neutral',
                    children: row.statusLabel || row.status
                })
        },
        ...dueColumn ? [
            {
                id: 'due',
                header: 'Response due',
                cell: (row)=>formatDueDate(row.dueAt)
            }
        ] : [],
        {
            id: 'updated',
            header: 'Updated',
            cell: (row)=>formatDueDate(row.updatedAt)
        }
    ];
    return /*#__PURE__*/ _jsx(SpecraDataTable, {
        columns: columns,
        rows: rows,
        loading: loading,
        getRowId: (row)=>row.id,
        rowTestId: Testids.growthWorkspaces.row,
        onRowClick: (row)=>row.href && navigate(row.href),
        getRowActionLabel: (row)=>`Open ${row.title}`,
        empty: empty,
        error: error
    });
}
